import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  EQUIPMENT_STOCK_DETAIL_LIST,
  EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK,
  EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION,
  EQUIPMENT_STOCK_DETAIL_ADD,
  EQUIPMENT_STOCK_DETAIL_DETAIL,
  EQUIPMENT_STOCK_DETAIL_UPDATE
} from '../../actions';

import {
  EquipmentStockDetailListSuccess,
  EquipmentStockDetailListError,
  EquipmentStockDetailSearchEquipmentStockSuccess,
  EquipmentStockDetailSearchEquipmentStockError,
  EquipmentStockDetailSearchApplyOptionSuccess,
  EquipmentStockDetailSearchApplyOptionError,
  EquipmentStockDetailAddSuccess,
  EquipmentStockDetailAddError,
  EquipmentStockDetailDetailSuccess,
  EquipmentStockDetailDetailError,
  EquipmentStockDetailUpdateSuccess,
  EquipmentStockDetailUpdateError
} from '../../actions';
 
export function* watchEquipmentStockDetailList() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_LIST, onEquipmentStockDetailList);
}

export function* watchEquipmentStockDetailSearchEquipmentStock() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_SEARCH_EQUIPMENT_STOCK, onEquipmentStockDetailSearchEquipmentStock);
}

export function* watchEquipmentStockDetailSearchApplyOption() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_SEARCH_APPLY_OPTION, onEquipmentStockDetailSearchApplyOption);
}

export function* watchEquipmentStockDetailAdd() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ADD, onEquipmentStockDetailAdd);
}

export function* watchEquipmentStockDetailDetail() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_DETAIL, onEquipmentStockDetailDetail);
}

export function* watchEquipmentStockDetailUpdate() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_UPDATE, onEquipmentStockDetailUpdate);
}

const onEquipmentStockDetailListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentStockDetailUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEquipmentStockDetailSearchEquipmentStockAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/equipment_stock', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailSearchApplyOptionAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/apply_option', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEquipmentStockDetailDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onEquipmentStockDetailList(data) {
  try {
    const response = yield call(onEquipmentStockDetailListAsync, data.payload);
    yield put(EquipmentStockDetailListSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailListError(error));
  }
}

function* onEquipmentStockDetailSearchEquipmentStock(data) {
  try {
    const response = yield call(onEquipmentStockDetailSearchEquipmentStockAsync, data.payload);
    yield put(EquipmentStockDetailSearchEquipmentStockSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailSearchEquipmentStockError(error));
  }
}

function* onEquipmentStockDetailSearchApplyOption(data) {
  try {
    const response = yield call(onEquipmentStockDetailSearchApplyOptionAsync, data.payload);
    yield put(EquipmentStockDetailSearchApplyOptionSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailSearchApplyOptionError(error));
  }
}

function* onEquipmentStockDetailAdd(data) {
  try {
      const response = yield call(onEquipmentStockDetailAddAsync, data);
      yield put(EquipmentStockDetailAddSuccess(response.data));
  } catch (error) {
      yield put(EquipmentStockDetailAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEquipmentStockDetailDetail(data) {
  try {
    const response = yield call(onEquipmentStockDetailDetailAsync, data.payload);
    yield put(EquipmentStockDetailDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EquipmentStockDetailDetailError(error));
  }
}

function* onEquipmentStockDetailUpdate(data) {
  try {
      const response = yield call(onEquipmentStockDetailUpdateAsync, data.payload);
      yield put(EquipmentStockDetailUpdateSuccess(response.data));
  } catch (error) {
      yield put(EquipmentStockDetailUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEquipmentStockDetailList),
    fork(watchEquipmentStockDetailSearchEquipmentStock),
    fork(watchEquipmentStockDetailSearchApplyOption),
    fork(watchEquipmentStockDetailAdd),
    fork(watchEquipmentStockDetailDetail),
    fork(watchEquipmentStockDetailUpdate),
  ]);
} 